import { render } from "./BottomClaim.vue?vue&type=template&id=54e05464&scoped=true"
import script from "./BottomClaim.vue?vue&type=script&lang=js"
export * from "./BottomClaim.vue?vue&type=script&lang=js"

import "./BottomClaim.vue?vue&type=style&index=0&id=54e05464&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e05464"]])

export default __exports__